import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/MemberDaybookReqs/MemberDaybookReqs'


function* getMemberDaybook(action) {
    try {
        const result = yield call(req.getMemberDaybookReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_MEMBER_DAYBOOK_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_MEMBER_DAYBOOK_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch member daybook");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_MEMBER_DAYBOOK_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


export default function* MemberDaybookSaga() {
    yield takeLatest(types.GET_MEMBER_DAYBOOK, getMemberDaybook);
}
